import { render, staticRenderFns } from "./InspectionCreateCardInspectionType.vue?vue&type=template&id=82b14172&"
import script from "./InspectionCreateCardInspectionType.vue?vue&type=script&lang=ts&"
export * from "./InspectionCreateCardInspectionType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports